import type { KinklistDoc } from '../model/types';

export const JSON_FILE_NAME = 'kinklist.json';
export const JSON_MIME = 'application/json';

/** The "Download data" file: the full v3 document, pretty-printed. */
export function serializeDoc(doc: KinklistDoc): string {
  return `${JSON.stringify(doc, null, 2)}\n`;
}
